var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.data.priceBuy)+" "+_vm._s(_vm.data.currencyBuy && _vm.data.currencyBuy.code)+" "),(_vm.data.incotermBuy)?[_vm._v("("+_vm._s(_vm.data.incotermBuy.name)+")")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }